import React from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import Page from "../Components/Page";
import {Breadcrumbs} from "../Components/Breadcrumbs";
import ProjectionStoresUpload from "./ProjectionStoresUpload";
import ProjectionUniverseUpload from "./ProjectionUniverseUpload";
import ProjectionCellTargetsUpload from "./ProjectionCellTargetsUpload";
import ProjectionCellToMarkets from "./ProjectionCellToMarkets";
import ProjectionCanonicalStoreOverridesUpload from "./ProjectionCanonicalStoreOverridesUpload";

const ProjectionUploads = () => {
    const pageName = 'Projection Uploads';

    return (
        <Page breadCrumbs={<Breadcrumbs items={[{label: "Services"}, {label: "Projections"}, {label: "Projection Uploads"}]}/>} name={pageName}>
            <Tabs>
                <TabList>
                    <Tab data-testid={'projection-stores-upload-tab-name'}>Stores</Tab>
                    <Tab data-testid={'projection-universe-upload-tab-name'}>Universe</Tab>
                    <Tab data-testid={'projection-cell-targets-upload-tab-name'}>Cell Targets</Tab>
                    <Tab data-testid={'projection-cell-to-markets-upload-tab-name'}>Cell To Markets</Tab>
                    <Tab data-testid={'projection-store-overrides-upload-tab-name'}>Store Overrides</Tab>
                </TabList>
                <TabPanel data-testid={'projection-stores-upload-tab-panel'}>
                    <ProjectionStoresUpload/>
                </TabPanel>
                <TabPanel data-testid={'projection-universe-upload-tab-panel'}>
                    <ProjectionUniverseUpload/>
                </TabPanel>
                <TabPanel data-testid={'projection-cell-targets-upload-tab-panel'}>
                    <ProjectionCellTargetsUpload/>
                </TabPanel>
                <TabPanel data-testid={'projection-cell-to-markets-upload-tab-panel'}>
                    <ProjectionCellToMarkets/>
                </TabPanel>
                <TabPanel data-testid={'projection-store-overrides-upload-tab-panel'}>
                    <ProjectionCanonicalStoreOverridesUpload/>
                </TabPanel>
            </Tabs>
        </Page>
    )
}

export default ProjectionUploads;
